import { type FC } from 'react';

import {
  ApplePayIconDark,
  ApplePayIconLight,
  GooglePayIcon
} from '@/components/ui/Icons/Icons';
import { useThemeMode } from '@/hooks/useThemeMode';
import { isAndroid, isIOS } from '@/utils/helpers/deviceDetectionHelper';

export const XPayIcon: FC = () => {
  const isLight = useThemeMode('dark');

  if (isAndroid()) return <GooglePayIcon />;
  if (isIOS()) return isLight ? <ApplePayIconLight /> : <ApplePayIconDark />;
  return null;
};
